import React from "react";

export const LoginIllustrator = (props) => {
  return (
    <svg width={471.3} height={456.9} viewBox="0 0 471.3 456.9" {...props}>
      <g transform="translate(-25.664 -30.517)">
        <ellipse fill="#F0F0F0" cx={261.3} cy={351.4} rx={235.7} ry={136} />
        <path
          fill="#E0E0E0"
          d="M396.7 398.6c-15.5-8.9-15.5-23.4 0-32.3s40.5-8.9 56 0 15.5 23.4 0 32.3-40.6 9-56 0zM82.4 399.9l-40.7-23.5c-2.3-1.3-2.3-3.5 0-4.8l236.4-136.5c2.6-1.3 5.7-1.3 8.3 0l40.7 23.5c2.3 1.3 2.3 3.5 0 4.8L90.7 399.9c-2.7 1.3-5.7 1.3-8.3 0z"
        />
        <path
          fill="#353596"
          d="M228.5 358.1l34.9-20.2c3.6-2.1 5.4-4.8 5.4-7.5v-4.9L232.6 305c-2.1-1.3-3.3-3.6-3.5-6v-43.1l-61 35.3v43.1c.1 2.4 1.4 4.7 3.5 6l30.8 17.8c7.2 4.1 18.9 4.1 26.1 0z"
        />
        <path
          fill="#252B43"
          d="M228.5 358.1l34.9-20.2c3.6-2.1 5.4-4.8 5.4-7.5v-4.9L232.6 305c-2.1-1.3-3.3-3.6-3.5-6v-43.1l-61 35.3v43.1c.1 2.4 1.4 4.7 3.5 6l30.8 17.8c7.2 4.1 18.9 4.1 26.1 0z"
          opacity={0.6}
        />
        <path
          fill="#252B43"
          d="M182.7 341.9v4.8l-11.2-6.4c-2.1-1.3-3.3-3.6-3.5-6v-43.1l11.6-6.7c.2 3 .5 6 .7 9l-8.2 4.7v33.7c.1 2.4 1.4 4.7 3.5 6l7.1 4z"
        />
        <path
          fill="#353596"
          d="M172.3 331.8c.1 2.4 1.4 4.7 3.5 6l26.6 15.3c7.2 4.2 18.9 4.2 26.1 0l35-20.2c7.2-4.2 7.2-10.9 0-15.1l-26.6-15.3c-2.1-1.3-3.3-3.6-3.5-6v-33.7l-61 35.3-.1 33.7z"
        />
        <path
          fill="#252B43"
          d="M172.3 331.8c.1 2.4 1.4 4.7 3.5 6l26.6 15.3c7.2 4.2 18.9 4.2 26.1 0l35-20.2c7.2-4.2 7.2-10.9 0-15.1l-26.6-15.3c-2.1-1.3-3.3-3.6-3.5-6v-33.7l-61 35.3-.1 33.7z"
        />
        <path
          fill="#252B43"
          d="M243.9 306.7l-7.1-4.1c-2.1-1.3-3.3-3.6-3.5-6v-33.7l-61 35.3v33.7c.1 2.4 1.4 4.7 3.5 6l7 4 61.1-35.2z"
        />
        <path
          fill="#353596"
          d="M268.8 325.5v4.9c0 2.7-1.8 5.4-5.4 7.5l-35 20.2c-3.8 2-8.1 3.1-12.5 3.1v-4.8c4.3 0 8.6-1 12.5-3.1l34.9-20.2c3.7-2.2 5.5-4.9 5.5-7.6z"
        />
        <path
          fill="#252B43"
          d="M268.8 325.5v4.9c0 2.7-1.8 5.4-5.4 7.5l-35 20.2c-3.8 2-8.1 3.1-12.5 3.1v-4.8c4.3 0 8.6-1 12.5-3.1l34.9-20.2c3.7-2.2 5.5-4.9 5.5-7.6z"
        />
        <path
          fill="#353596"
          d="M74.3 373.7c2.7 1.3 5.8 1.2 8.4-.2l236.1-136.2c2.6-1.7 4.2-4.5 4.3-7.5v-191c-.1-3-1.6-5.7-4.1-7.4-2.7-1.3-5.8-1.2-8.4.2L74.5 167.9c-2.6 1.7-4.2 4.5-4.3 7.5v190.9c.1 3 1.6 5.7 4.1 7.4z"
        />
        <path
          fill="#353596"
          d="M82.7 373.5l236.1-136.2c2.6-1.7 4.2-4.5 4.3-7.5v-191c0-2.8-1.9-3.9-4.3-2.5L82.7 172.6c-2.6 1.7-4.2 4.5-4.3 7.5V371c-.1 2.8 1.9 3.9 4.3 2.5z"
        />
        <path
          fill="#252B43"
          d="M82.7 373.5l236.1-136.2c2.6-1.7 4.2-4.5 4.3-7.5v-191c0-2.8-1.9-3.9-4.3-2.5L82.7 172.6c-2.6 1.7-4.2 4.5-4.3 7.5V371c-.1 2.8 1.9 3.9 4.3 2.5z"
        />
        <path
          fill="#353596"
          d="M82.1 378.5c-2.5 1.1-5.3 1-7.8-.2-2.5-1.7-4-4.4-4.1-7.4v-17.4l8.2 4.7v17.4c-.1 2.6 1.5 3.7 3.7 2.9z"
        />
        <path
          fill="#252B43"
          d="M82.1 378.5c-2.5 1.1-5.3 1-7.8-.2-2.5-1.7-4-4.4-4.1-7.4v-17.4l8.2 4.7v17.4c-.1 2.6 1.5 3.7 3.7 2.9z"
        />
        <path
          fill="#353596"
          d="M78.3 358.3v17.4c0 2.8 1.9 3.9 4.3 2.5L318.7 242c2.6-1.7 4.2-4.5 4.3-7.5V217L78.3 358.3z"
        />
        <path
          fill="#252B43"
          d="M78.3 358.2v17.4c0 2.8 1.9 3.9 4.3 2.5l236.1-136.2c2.6-1.7 4.2-4.5 4.3-7.5V217L78.3 358.2z"
        />
        <path
          fill="#353596"
          d="M86.5 336.4V182.8c.1-1.8 1.1-3.5 2.6-4.5L312.3 49.4c1.4-.8 2.6-.2 2.6 1.5v153.7c-.1 1.8-1.1 3.5-2.6 4.5L89.1 338c-1.4.8-2.6.1-2.6-1.6z"
        />
        <path
          fill="#252B43"
          d="M86.5 336.4V182.8c.1-1.8 1.1-3.5 2.6-4.5L312.3 49.4c1.4-.8 2.6-.2 2.6 1.5v153.7c-.1 1.8-1.1 3.5-2.6 4.5L89.1 338c-1.4.8-2.6.1-2.6-1.6z"
        />
        <path
          fill="#353596"
          d="M200.7 293.1c-2.4 1.6-3.9 4.2-4.1 7.1 0 2.6 1.8 3.7 4.1 2.4 2.4-1.6 3.9-4.2 4.1-7.1 0-2.6-1.8-3.7-4.1-2.4z"
        />
        <path
          fill="#252B43"
          d="M79.6 175.8c-.8 1.3-1.2 2.8-1.3 4.3v178.2l-8.2-4.7V175.4c.1-1.5.5-3 1.3-4.3l8.2 4.7zM323.1 38.1c-.3-2.2-2.1-3.1-4.3-1.8l-236 136.3c-1.3.8-2.3 1.9-3.1 3.2l-8.2-4.7c.7-1.3 1.8-2.4 3.1-3.2l236-136.2c2.6-1.4 5.8-1.5 8.4-.2 2.3 1.5 3.7 3.9 4.1 6.6z"
        />
        <g>
          <path
            fill="#353596"
            d="M335.8 61.6c-.7-.4-1.6-.3-2.2.2L110.8 190.4c-1.8 1.2-2.9 3.1-3 5.3v152.7c-.1 1 .4 2.1 1.3 2.6.5.3 3.1 1.8 3.9 2.2.6.3 1.2.2 1.8-.1l222.7-128.6c1.8-1.2 2.9-3.1 3-5.3V65.7c.1-.8-.3-1.6-.9-2-.6-.3-3.2-1.8-3.8-2.1z"
          />
          <path
            fill="#FAFAFA"
            d="M113.7 352.9c-.5 0-.9-.3-1.1-.6-.3-.4-.5-1.1-.5-1.7V197.8c0-.9.3-1.8.8-2.8.5-.9 1.2-1.7 2-2.1L337.7 64.4c.4-.2.8-.3 1.1-.3.7 0 1.2.6 1.2 1.7v153.5c0 .9-.3 1.8-.8 2.8-.5.9-1.2 1.7-2 2.1L114.5 352.7c-.3.1-.5.2-.8.2z"
          />
          <path
            fill="#E0E0E0"
            d="M338.8 64.6c-.2 0-.5 0-.9.3L115.2 193.4c-1.4.8-2.5 2.8-2.5 4.4v152.7c0 1 .5 1.8 1 1.8.2 0 .3-.1.5-.2L337 223.6c1.4-.8 2.5-2.8 2.5-4.4V65.7c0-.4-.1-.8-.2-1-.1 0-.2-.1-.5-.1m0-1c1 0 1.7.8 1.7 2.2v153.5c0 1.9-1.4 4.3-3.1 5.3L114.7 353.1c-.4.2-.7.3-1 .3-1.2 0-2-1.3-2-2.8V197.8c0-1.9 1.4-4.3 3-5.3L337.5 64c.5-.3.9-.4 1.3-.4z"
          />
          <path
            fill="#F0F0F0"
            d="M109.1 351c.3.2 2.7 1.5 3.7 2.1-.8-.6-1.2-1.6-1.1-2.6V207.8l-3.9-2.3v142.8c-.1 1.1.4 2.1 1.3 2.7z"
          />
          <g>
            <path
              fill="#353596"
              d="M340.5 65.7c0-1.9-1.4-2.7-3-1.7L114.7 192.6c-1.8 1.2-2.9 3.1-3 5.3v10L340.5 75.7v-10z"
            />
            <path
              opacity={0.4}
              fill="#FFF"
              d="M337.5 64L114.7 192.6c-.9.6-1.6 1.3-2.1 2.3l-3.9-2.2c.5-.9 1.2-1.7 2.1-2.2L333.6 61.8c.6-.5 1.5-.5 2.2-.2.5.3 3.1 1.8 3.7 2.1-.7-.2-1.4-.1-2 .3z"
            />
            <path
              fill="#252B43"
              d="M107.8 205.5v-9.9c0-1.1.4-2.1.9-3l3.9 2.2c-.6.9-.9 2-.9 3v10l-3.9-2.3z"
            />
          </g>
          <g>
            <path
              fill="#353596"
              d="M293.5 180.8l-133.4 77c-1.3.9-2.1 2.3-2.2 3.9v38.2c.1 1.6.9 3 2.2 3.9l3.9 2.2c1.4.7 3.1.7 4.5 0l133.4-77c1.3-.9 2.1-2.3 2.2-3.9v-38.2c-.1-1.6-.9-3-2.2-3.9l-3.9-2.2c-1.4-.7-3.1-.7-4.5 0z"
            />
            <path
              opacity={0.5}
              fill="#FFF"
              d="M304.1 186.6c-.2-1.2-1.1-1.6-2.2-.9l-133.4 77c-.7.4-1.2 1-1.6 1.7l-8.4-4.8c.4-.7.9-1.2 1.6-1.6l133.4-77c1.4-.7 3.1-.7 4.5 0l3.9 2.2c1.2.7 2 1.9 2.2 3.4z"
            />
            <path
              fill="#252B43"
              d="M168.1 306.2c-1.3.5-2.8.5-4.1-.2l-3.9-2.2c-1.3-.9-2.1-2.3-2.2-3.9v-38.2c0-.8.3-1.5.7-2.2l8.4 4.8c-.4.7-.6 1.4-.7 2.2v38.2c0 1.3.8 1.9 1.8 1.5z"
            />
            <path
              fill="#353596"
              d="M168.5 262.6l133.4-77c1.2-.7 2.2-.1 2.2 1.3v38.2c-.1 1.6-.9 3-2.2 3.9l-133.4 77c-1.2.7-2.2.1-2.2-1.3v-38.2c0-1.6.9-3 2.2-3.9z"
            />
            <path
              fill="#252B43"
              d="M258.2 201.2l-98 56.6c-.7.4-1.2 1-1.6 1.6l8.4 4.8c.4-.7.9-1.3 1.6-1.7l98-56.6-8.4-4.7z"
            />
            <path
              fill="#252B43"
              d="M266.5 206.1l-98 56.6c-1.3.9-2.1 2.3-2.2 3.9v38.2c0 1.4 1 2 2.2 1.3l98-56.6v-43.4z"
            />
            <g>
              <path
                fill="#353596"
                d="M191.1 258l50.6-29.2c2.1-1.2 3.8-.4 3.8 1.9-.2 2.6-1.6 4.9-3.8 6.3l-50.6 29.2c-2.1 1.2-3.8.4-3.8-1.9.2-2.6 1.6-4.9 3.8-6.3z"
              />
            </g>
            <g fill="#FAFAFA">
              <path d="M201.5 267.6h.1c0 .1.1.1.1.2v5.7c0 .5 0 1.1-.1 1.6s-.2 1-.4 1.4c-.2.4-.4.8-.7 1.2-.3.3-.6.6-1 .8-.3.2-.6.3-1 .3-.3 0-.5-.2-.7-.4-.2-.3-.4-.6-.4-1-.1-.5-.1-1-.1-1.5v-5.7c0-.1 0-.2.1-.3 0-.1.1-.2.1-.2l.6-.4h.1c0 .1.1.1.1.2v5.6c0 .3 0 .6.1.9 0 .2.1.4.2.5.1.1.2.2.4.2s.3-.1.5-.2.3-.2.5-.4.3-.4.4-.6c.1-.3.2-.5.2-.8.1-.3.1-.7.1-1v-5.6c0-.1 0-.2.1-.3 0-.1.1-.2.1-.2h.6zM205.4 273c0-.1 0-.2-.1-.2s-.1-.1-.2-.1h-.4c-.2 0-.3.1-.6.1h-.6c-.1-.1-.3-.1-.4-.3-.1-.2-.2-.3-.2-.5s-.1-.5-.1-.7c0-.3 0-.6.1-.9l.3-.9c.1-.3.3-.6.5-.8.2-.2.4-.4.7-.6.2-.1.4-.2.7-.2.2 0 .4 0 .5.1.1.1.3.2.3.4.1.2.1.4.1.6 0 .1 0 .2-.1.3 0 .1-.1.2-.2.2l-.6.3c-.1 0-.1.1-.2 0l-.1-.1c-.1 0-.1-.1-.2-.1s-.2.1-.4.1c-.2.1-.3.2-.4.4-.1.2-.2.4-.2.5v.2c0 .1.1.1.2.1h.3c.1 0 .3-.1.6-.1.3-.1.7 0 1 .3.2.4.3.8.3 1.2 0 .3 0 .6-.1.9l-.3.9c-.1.3-.3.6-.5.8-.2.2-.5.4-.7.6-.2.1-.5.2-.7.2-.2 0-.4 0-.5-.1-.2-.1-.3-.3-.3-.4-.1-.2-.1-.4-.1-.6 0-.1 0-.2.1-.3 0-.1.1-.2.2-.2l.6-.3h.2c.1 0 .1.1.1.1.1.1.1.1.2.1s.3-.1.4-.1c.1 0 .2-.1.2-.2.1-.1.2-.1.2-.2.1-.1.1-.2.2-.3.2 0 .2-.1.2-.2zM207.4 270.3c0-.5 0-1 .1-1.5s.2-1 .4-1.4c.2-.4.4-.8.6-1.1.2-.3.5-.6.8-.7.2-.2.5-.2.8-.2.2.1.5.2.6.4.2.3.3.6.4.9.1.4.1.8.1 1.3v.6c0 .1 0 .2-.1.3 0 .1-.1.2-.1.2l-2.6 1.5c0 .2 0 .4.1.5 0 .1.1.2.2.3.1.1.2.1.3.1.1 0 .2 0 .3-.1.2-.1.3-.2.4-.3.1-.1.2-.2.3-.4 0-.1.1-.2.1-.2 0-.1.1-.1.1-.1l.6-.4h.2c0 .1.1.1.1.2 0 .2-.1.4-.1.6-.1.3-.2.5-.3.8-.2.3-.3.6-.6.8-.2.3-.5.5-.8.7-.2.2-.5.2-.8.2-.3-.1-.5-.2-.6-.4-.2-.3-.3-.6-.4-1 0-.6-.1-1.1-.1-1.6zm1.9-3.2c-.2.1-.3.2-.4.3-.1.1-.2.3-.3.5-.1.2-.1.3-.2.5 0 .2-.1.3-.1.5l1.8-1c0-.1 0-.3-.1-.4 0-.1-.1-.2-.1-.3-.1-.1-.2-.1-.3-.2 0 0-.1 0-.3.1zM214.4 264.3c-.3.2-.5.4-.7.8-.2.4-.2.9-.2 1.3v3.6c0 .1 0 .2-.1.3 0 .1-.1.2-.1.2l-.6.3h-.1c0-.1-.1-.1-.1-.2v-6.5c0-.1 0-.2.1-.3 0-.1.1-.2.1-.2l.6-.3h.1c0 .1.1.1.1.2v.3c.1-.3.3-.5.4-.8.2-.2.4-.4.6-.5l.4-.2h.1c0 .1.1.1.1.2v.9c0 .1 0 .2-.1.3 0 .1-.1.2-.1.2l-.5.4zM221.9 263.9h.1c0 .1.1.1.1.2v1c0 .1 0 .2-.1.3 0 .1-.1.2-.1.2l-3.4 2h-.1c0-.1-.1-.1-.1-.2v-9c0-.1 0-.2.1-.3 0-.1.1-.2.1-.2l.6-.4h.1c0 .1.1.1.1.2v7.6l2.6-1.4zM224.9 256.5c.2-.2.5-.2.8-.2.2 0 .4.1.6.3.2.2.3.5.4.7.1.4.2.7.2 1.1V259.8c0 .4-.1.9-.2 1.3s-.2.8-.4 1.2c-.2.4-.4.7-.6 1-.2.3-.5.5-.8.7-.2.2-.5.2-.8.2-.2 0-.4-.1-.6-.3-.2-.2-.3-.5-.4-.7-.1-.4-.2-.7-.2-1.1v-.3-.4-.4-.3c0-.9.2-1.7.6-2.5.2-.4.4-.7.6-1 .3-.3.5-.6.8-.7zm1 2.5c0-.2 0-.4-.1-.6 0-.1-.1-.2-.2-.3-.1-.1-.2-.1-.3-.1-.1 0-.2.1-.3.1-.1.1-.2.2-.3.2-.1.1-.2.3-.3.4-.1.2-.2.4-.2.6-.1.3-.1.5-.1.8v1.3c0 .2 0 .4.1.6 0 .1.1.2.2.3.1.1.2.1.3.1.1 0 .2-.1.3-.1.1-.1.2-.2.3-.2.1-.1.2-.3.3-.4.1-.2.2-.4.2-.6.1-.3.1-.5.1-.8v-1-.3zM230 262.3l.3-.3c.1-.1.2-.3.3-.5.1-.2.2-.4.2-.6.1-.2.1-.5.1-.8v-.5c0 .1-.1.2-.2.4-.1.1-.2.3-.2.4-.1.1-.2.3-.3.4-.1.1-.3.2-.4.3-.2.1-.5.2-.7.1-.2-.1-.4-.2-.5-.4-.2-.3-.3-.5-.4-.8-.1-.4-.1-.8-.1-1.1v-.5-.5c0-.4.1-.9.1-1.3.1-.4.2-.8.4-1.2.1-.4.3-.7.5-1 .2-.3.4-.5.7-.7.1-.1.3-.1.4-.2h.3c.1 0 .2.1.2.1l.2.2v-.3c0-.1 0-.2.1-.3 0-.1.1-.2.1-.2l.6-.3h.1c0 .1.1.1.1.2v6.5c0 1-.2 1.9-.5 2.8-.3.7-.8 1.3-1.5 1.7-.2.1-.5.2-.7.2-.2 0-.4 0-.6-.2-.2-.1-.3-.3-.4-.5-.1-.2-.2-.5-.2-.7 0-.1 0-.2.1-.3 0-.1.1-.2.2-.2l.5-.3h.2c0 .1.1.1.1.2.1.1.2.2.3.2.2.2.4.1.6 0zm-1-4.8v.8c0 .4.1.8.3 1.1.2.2.5.2.6 0 .3-.2.5-.5.6-.8.2-.4.3-.9.3-1.3v-.5-.5c0-.3-.1-.7-.3-1-.2-.2-.5-.2-.6 0-.3.2-.5.5-.6.8-.2.3-.3.9-.3 1.4zM234.3 248.6h.1c0 .1.1.1.1.2v1.1c0 .1 0 .2-.1.3 0 .1-.1.2-.1.2l-.7.4h-.1c0-.1-.1-.1-.1-.2v-1.1c0-.1 0-.2.1-.3 0-.1.1-.2.1-.2l.7-.4zm.1 9.4c0 .1 0 .2-.1.3 0 .1-.1.2-.1.2l-.6.3h-.1c0-.1-.1-.1-.1-.2v-6.5c0-.1 0-.2.1-.3 0-.1.1-.2.1-.2l.6-.3h.1c0 .1.1.1.1.2v6.5zM239.7 254.9c0 .1 0 .2-.1.3 0 .1-.1.2-.1.2l-.6.3h-.1c0-.1-.1-.1-.1-.2V252c0-.4 0-.8-.2-1.2-.1-.2-.4-.3-.7-.1-.3.2-.5.5-.7.9-.2.5-.2 1-.2 1.5v3.5c0 .1 0 .2-.1.3 0 .1-.1.2-.1.2l-.6.3h-.1c0-.1-.1-.1-.1-.2v-6.5c0-.1 0-.2.1-.3 0-.1.1-.2.1-.2l.6-.3h.1c0 .1.1.1.1.2v.3c.1-.3.3-.6.5-.9.2-.2.4-.5.6-.6.2-.2.5-.2.8-.2.2.1.4.2.5.4l.3.9c.1.4.1.8.1 1.2v3.7z" />
            </g>
            <g fill="#252B43">
              <path d="M290.2 225.8l-9.7 5.6 1.5-13.6c-1.2-.6-1.9-2.1-1.9-4.3 0-3.9 2.4-8.4 5.3-10s5.3.1 5.3 4c-.1 2.3-.7 4.5-1.9 6.5l1.4 11.8z" />
              <path d="M290.2 225.8l-8.6-4.9-1.2 10.5 9.8-5.6zM285.3 203.5c-2.1 1.4-3.7 3.5-4.5 5.9l7.8 4.5c1.2-2 1.8-4.2 1.9-6.5.1-3.8-2.3-5.6-5.2-3.9z" />
            </g>
          </g>
          <g>
            <path
              fill="#353596"
              d="M238.1 158.1c-3.3-1.9-7.9-1.7-13 1.3-10.1 5.9-18.4 20.1-18.4 31.8 0 5.9 2.1 10 5.4 11.9.9.5 5.6 3.2 6.5 3.8 3.3 1.9 7.9 1.6 13-1.3 10.1-5.9 18.4-20.1 18.4-31.8 0-5.9-2.1-10-5.4-11.9"
            />
            <path
              fill="#353596"
              d="M231.6 163.2c-10.1 5.9-18.4 20.1-18.4 31.8s8.2 16.5 18.4 10.6 18.4-20.1 18.4-31.8-8.3-16.5-18.4-10.6z"
            />
            <path
              fill="#353596"
              d="M241.7 189.1v1.3c-2.4 4.3-5.9 8-10.1 10.6-4 2.3-7.5 2.5-10.1 1.1v-2.8c.3-5.8 3.4-11.2 8.3-14.3l2.7-1.5c2.4-1.4 4.7-1.5 6.5-.5 1.7 1.1 2.7 3.3 2.7 6.1z"
            />
            <path
              opacity={0.4}
              fill="#FFF"
              d="M238.1 158.1l6.5 3.8c-3.3-1.9-7.9-1.7-13 1.3-6.6 3.8-12.5 11.3-15.7 19.2l-6.5-3.8c3.2-8 9-15.4 15.7-19.2 5.1-2.9 9.7-3.2 13-1.3z"
            />
            <path
              fill="#252B43"
              d="M218.4 206.7c-1.1-.7-5.4-3.2-6.2-3.6-3.3-1.9-5.4-6-5.4-11.9l6.5 3.8c-.1 5.7 1.9 9.7 5.1 11.7z"
            />
            <path
              fill="#252B43"
              d="M209.4 178.6l6.5 3.8c-1.7 4-2.6 8.3-2.7 12.6l-6.5-3.8c.1-4.3 1-8.6 2.7-12.6z"
            />
            <g>
              <path
                fill="#FFF"
                d="M229.3 182.9c-.6 0-1.2-.2-1.8-.5-1.3-.9-2.1-2.4-1.9-4 .2-3.7 2.1-7.1 5.2-9.1 1.7-1.4 4.2-1.1 5.5.6.7.9 1 2 .8 3-.2 3.7-2.1 7.1-5.2 9.1-.8.6-1.7.9-2.6.9zM238.8 183.1c-1.8-1-4.1-.9-6.5.5l-2.7 1.5c-4.9 3.2-8 8.5-8.3 14.3v2.8c2.6 1.5 6.2 1.2 10.1-1.1 4.2-2.6 7.7-6.3 10.1-10.6v-1.3c.2-2.9-.8-5.1-2.7-6.1z"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            fill="#353596"
            d="M444.5 356.1s1.3-11.7 7.1-20.7 13.8-14.7 21.2-15.3 13.5 6.3 5.5 11-22.1 9.5-28.7 27.1l-5.1-2.1z"
          />
          <path
            fill="#252B43"
            d="M444.5 356.1s1.3-11.7 7.1-20.7 13.8-14.7 21.2-15.3 13.5 6.3 5.5 11-22.1 9.5-28.7 27.1l-5.1-2.1z"
          />
          <g>
            <path
              fill="#FFF"
              d="M446.7 353c-.1 0-.1 0 0 0-.3-.1-.4-.3-.3-.5 7.9-19.4 22.8-27.4 29.6-29 .2 0 .4.1.4.3 0 .2-.1.4-.3.4-6.7 1.5-21.3 9.5-29.1 28.5 0 .3-.1.4-.3.3z"
            />
          </g>
          <g>
            <path
              fill="#353596"
              d="M486.5 353.3c-.7 1.5-2.3 2.3-3.9 2.9s-3.2 1.3-4.1 2.7c-1.7 2.9 1.1 7-.7 9.8-.9 1.1-2.1 1.9-3.6 2.1-1.2.2-2.3.3-3.5.3-.6 0-1.1-.1-1.7-.1-1.6-.4-3.3-.2-4.8.5-2.3 1.3-3 4.2-4.4 6.5-1.8 2.7-4.6 4.5-7.8 4.9-1 .1-3 .3-4-.3-.1 0-.1-.1-.2-.1-.1-.2-.3-.4-.4-.5v-.1c-.4-1.5.3-3.1.3-4.6v-.3c-.1-1.8-.1-3.6-.2-5.4-.1-3.3-.1-6.6-.1-10 0-2.2-.2-4.5.7-6.5 1-2.2 3.5-2.3 4.5-4.5.4-.9.6-1.8 1-2.7 1.2-2.6 3.7-4.4 6.6-4.6 4.4-.2 8.3 3.3 12.7 3 1.1-.2 2.3-.4 3.4-.6 3.6-.7 7.7.3 9.7 3.4.8 1.1 1 2.7.5 4.2z"
            />
            <path
              fill="#FFF"
              d="M447 374.9c-.2-.1-.3-.3-.3-.5 6.1-22.7 30-26 35.6-25.6.2 0 .4.2.3.4 0 .2-.2.4-.4.3-5.5-.4-28.9 2.8-34.9 25.1.1.2-.1.4-.3.3z"
            />
            <path
              fill="#FFF"
              d="M473.7 363.4c-.1 0-.1-.1-.2-.1-4.5-3.9-10.5-5.6-16.3-4.6-.2 0-.4-.1-.4-.3 0-.2.1-.4.3-.4 6.1-1 12.3.8 17 4.8.1.1.1.4 0 .5-.2.1-.3.1-.4.1z"
            />
          </g>
        </g>
        <g fill="#E6E6E6">
          <path d="M389.4 81.4l3.2 1.2v-7c0-5.6 4.4-6.9 9.2-4.1 4.8 2.8 8.7 9.5 8.7 15.1v1c1.4-.4 2.9-.2 4 .6 3.7 2.4 6 6.4 6.3 10.9v.5l4.4 2.6c2.4 1.6 4 4.2 4.1 7.2 0 2.6-1.8 3.7-4.1 2.4L389.4 91c-2.4-1.6-4-4.2-4.1-7.2 0-2.6 1.8-3.7 4.1-2.4zM432 75.9l5.8 3.3v-2.5c0-3 2.1-4.2 4.7-2.7 1.1.7 2.1 1.6 2.8 2.7.4-3.7 3.4-5.1 6.9-3.1 4.1 2.7 6.7 7.2 7 12.1v2.5c0 1-.2 2-.6 2.9l4.8 2.8c1.5 1 2.5 2.7 2.6 4.5 0 1.6-1.2 2.3-2.6 1.5l-31.4-18c-1.5-1-2.5-2.7-2.6-4.5 0-1.7 1.2-2.4 2.6-1.5z" />
        </g>
        <g>
          <path
            fill="#FFCDA7"
            d="M409.7 227.6c-4.2 7.1-8.2 13.3-11.1 16.2-5.4 2.5-18 6.4-23 7-.9.1-1.8-.1-2.5-.6-1.9-1.3-3.5-1.5-5.5-2.2-1.6-.6-2.3-1.3-2.6-1-.6.8-.6 1.9.2 2.5.8.7 1.6 1.4 2.5 1.9-2.2.5-4.5.6-6.7.1-4.3-1.1-6.3.9-3.4 5.6 1 1.7 5.1 4.3 13.4 3.6 3-.2 5.9-.5 8.8-1 7.9-1.7 16.8-3.3 22.2-5 2-.8 3.8-2 5.3-3.7 9.1-10.4 12.2-17.8 16.2-24.6l-.3-11c-6.5 0-10 6.3-13.5 12.2z"
          />
          <path
            fill="#252B43"
            d="M424.3 215.4c-3.8-.5-7.6 1.1-9.9 4.2-4.5 5.7-12.4 19.4-12.4 19.4s2.6 6.9 9.5 8l11.2-15.1s5.3-10.4 1.6-16.5z"
          />
          <path
            fill="#FFCDA7"
            d="M441.1 368.9h7.3v13h-7.3zM423.2 368.3l-7.3.3-.4-13.7 7.6-.3.1 13.7z"
          />
          <path
            fill="#252B43"
            d="M449.4 256.8c0 7.2-1.1 65.4-1.1 65.4.2 2.1 2 5.9 1.6 13.9-.5 10.9-1.3 39.4-1.3 39.4-2.5 1.3-5.5 1.4-8.1.2 0 0-5.9-40-7.2-50.7-1.1-9.4-4-40.5-4-40.5l-3.9 36.7c.8 4 1.1 8 .9 12-.3 5-2.7 30.9-2.7 30.9-2.5 1.5-5.6 1.8-8.4.7 0 0-4.1-39-4.2-43.6-.1-5.2 2.4-64.4 2.4-64.4h36zM441.1 378.2v-1.1c-.7.3-2.3 6.7-5.2 9.5-2.3 2.2-5.4 4.7-6.2 7.1-.8 2.5 4.4 3.9 6.5 3.5 2.5-.5 6.8-2.3 7.9-4s1.6-4.2 2.5-5.4 2.9-2.6 3.4-4.1c.1-1.3 0-2.7-.4-4-.3-1.3-.7-2.8-1.1-2.7v.8c-1 .8-2.3 1.3-3.6 1.3-1.2.1-3.8-.1-3.8-.9z"
          />
          <path
            fill="#252B43"
            d="M415.8 366.2c-.4 0-.7.6-1.5 1.5-1.2 1.3-2.7 2.4-4.3 3.2-2.7 1.4-8 3.6-10.4 4.7-1.5.7-1.4 2.6.1 3.7s5.3 1.8 9.8.8c2.4-.6 5.6-2.9 7.6-2.8s5.8.1 7.3-1 .9-3.3.5-5.3c-.5-2.1-1-5.5-1.7-5.3v.7c-.9 1.4-5.4 1.9-7.3.9l-.1-1.1zM429.3 284.4c-3.8-1.2-7.2-3.3-10.1-6 0 0 2 3.8 7.8 7.4l-1.2 32.8 3.5-34.2z"
          />
          <g>
            <path
              fill="#353596"
              d="M445.3 216.5s6 1.4 5.6 12.2l-1.3 17.3v25.9c-5.3 6.1-29 5.6-37.2-.5 0 0 .9-30.6 1.5-42.4.4-8.4 2.3-12.6 10.6-13.5l10.1.4 10.7.6z"
            />
          </g>
          <g>
            <path
              fill="#252B43"
              d="M437.7 193.9c.1 6.1-4.7 11.1-10.8 11.3-6 0-9.5-5.2-10.8-11.3-2.4-11.1 4.8-11.3 10.8-11.3 6.1.2 10.9 5.2 10.8 11.3zM443.2 198.5s-1.7 8.1-2.3 9.5c-.4.8-1.2 1.4-2 1.7l.1-5.7 4.2-5.5z"
            />
            <path
              fill="#252B43"
              d="M441.1 186.9s1.2-.3 2.5 1.7c1.1 1.7 1.3 5.5-.4 10l-3.1.4 1-12.1z"
            />
            <path
              fill="#252B43"
              d="M442.3 188.5l3.8.1c.1-1-.6-1.9-1.6-2h-.2c-1 0-1.9.8-2 1.9z"
            />
            <path
              fill="#252B43"
              d="M442.7 187.6l2.8-2.7c-.7-.8-1.8-.9-2.6-.2l-.1.1c-.7.7-.8 2-.1 2.8z"
            />
            <path
              fill="#FFCDA7"
              d="M439.1 198.9c.6.4 1.5-.9 2.3-1.7s3.2-1.6 4.5 1.1c1.3 2.8-.9 5.5-2.7 6.4-3.2 1.6-4.3-.7-4.3-.7l-.3 12.9c-4.5 7-14.8 6.8-11.1-.3v-3.9c-1.5.3-3.1.3-4.6.2-2.5-.4-4.1-2.5-4.9-5.3-1.2-4.6-1.7-8.2-.7-17.2 1.1-9.8 12.1-9.9 18-6s3.8 14.5 3.8 14.5z"
            />
            <path
              fill="#252B43"
              d="M425.5 188.8c2.6-.3 5.2-.8 7.8-1 .6-.1 1.1 0 1.7.1 2 .5 1.8 2.9 2.1 4.5.6 2.8 1 7.6 2.1 7.6.3 0 1.5-2.1 2.3-2.8.4-.6.7-1.4.7-2.1.2-1.2.3-2.4.4-3.5.1-1 .2-2 .2-3 .1-1.1 0-2.3-.3-3.4-.2-.9-.7-1.8-1.4-2.5l-.2-.2c-1.3-1.4-2.9-2.5-4.7-3.2-2.6-1-5.2-1.5-7.9-1.7-2.7-.2-5.4-.5-8.1-1h-.5c-.2.1-.4.3-.4.6-.2 1.3.3 2.6 1.4 3.3-1.8.1-3.9-.8-5.6-1.3-.3-.1-.6-.1-.9 0-.2.1-.3.3-.4.5-.1.5-.1 1 0 1.4.2 1.4.7 2.8 1.6 4 1.4 1.8 3.3 3 5.4 3.5 1.4.3 3.1.3 4.7.2z"
            />
            <path
              fill="#F28F8F"
              d="M427.6 212.6s5.6-1.2 7.6-2.3c1.2-.6 2.1-1.6 2.7-2.8-.3 1.2-.8 2.3-1.5 3.3-1.4 1.9-8.8 3.3-8.8 3.3v-1.5z"
            />
            <g>
              <path
                fill="#252B43"
                d="M428.9 197.4c.1.6.6 1.1 1.2 1 .6-.1 1.1-.6 1-1.2 0-.6-.5-1-1.1-1-.6 0-1.1.6-1.1 1.2zM430.7 192.6l2.4 1.4c.4-.7.1-1.6-.6-2-.6-.4-1.4-.1-1.8.5.1 0 0 0 0 .1z"
              />
              <path
                fill="#F28F8F"
                d="M428.1 205.5l-2.6 1c.2.7.9 1.1 1.7.9h.1c.7-.3 1-1.1.8-1.9z"
              />
              <path
                fill="#252B43"
                d="M418.6 193.6l2.2-1.8c-.4-.6-1.2-.8-1.8-.4l-.1.1c-.6.5-.8 1.4-.3 2.1zM419.5 197.1c.1.6.6 1.1 1.2 1 .6-.1 1.1-.6 1-1.2 0-.6-.5-1-1.1-1-.6 0-1.1.5-1.1 1.2z"
              />
              <path fill="#F28F8F" d="M425.6 196.1l-.1 7.1-4-.9 4.1-6.2z" />
            </g>
          </g>
          <g>
            <path fill="#353596" d="M329.6 255.7l6.3-3.6 2.5-3-6.3 3.6-2.5 3" />
            <path fill="#252B43" d="M329.6 255.7l6.3-3.6 2.5-3-6.3 3.6-2.5 3" />
            <path
              fill="#353596"
              d="M346.7 265.5l6.3-3.6 5.2-4.6-6.3 3.6-5.2 4.6"
            />
            <path
              fill="#252B43"
              d="M346.7 265.5l6.3-3.6 5.2-4.6-6.3 3.6-5.2 4.6"
            />
            <path
              fill="#353596"
              d="M399.9 278c1.5 2 2.4 4.3 2.6 6.8-1.4-1.9-2.3-4.3-2.6-6.8zm14.6.2c-2.1-14.4-9.8-28.5-19-33.9-4.4-2.5-8.5-2.6-11.8-.7-1 .6-4.5 2.6-5.9 3.4-.1.1-.2.1-.3.2-.3.1-.5.3-.8.5-.5.3-.9.7-1.4 1.1l-.2.2c-.2.2-.4.4-.5.6-.2.2-.4.5-.6.8l-1.2 1.8c-.2.3-.4.6-.5 1l-51.5-29.7-6.3 3.6v4l.5.3.5.3v.8l-1 .6v2.3l7.6 16 7.5 4.3 2.5-3 6.6 3.9 3.8 6.5 4.2 2.4 5.2-4.6 6.4 3.7 2.2 8.9 10.8 6.2c.5 2.3 1.2 4.5 2 6.7.1.2.2.5.2.7 3.6 9.4 9.3 17.5 15.7 21.2.8.5 1.6.8 2.4 1.2.4.2.9.3 1.3.5l1.2.3c1.3.2 2.6.2 3.8 0l.5-.1c.2-.1.5-.1.7-.2l.6-.2.6-.3c.2-.1.4-.2.5-.3.1-.1.2-.1.3-.2 0 0 .1 0 .1-.1 1.4-.8 5-2.9 5.9-3.4 4.8-2.8 7.8-9.7 7.8-19.6.2-2.6 0-5.2-.4-7.7z"
            />
            <path
              fill="#353596"
              d="M398.1 290.1c-2.5-1.4-4.5-5.7-4.5-9.5s2-5.7 4.5-4.3 4.5 5.7 4.5 9.5-2 5.8-4.5 4.3zm10.1-8.3c-2.1-14.3-9.8-28.5-19-33.8-4.3-2.5-8.2-2.6-11.4-.9-.1.1-.2.1-.3.2-.3.1-.5.3-.8.5-.5.3-.9.7-1.4 1.1l-.2.2c-.2.2-.4.4-.5.6-.2.2-.4.5-.6.8l-1.2 1.8c-.2.3-.4.6-.5 1-.9 1.9-1.6 4-2 6.1L314.6 227v4l.5.3.5.3v.8l-1 .6v2.3l7.6 16 7.5 4.3 2.5-3 6.6 3.9 3.8 6.5 4.2 2.4 5.2-4.6 6.4 3.7 2.2 8.9 10.8 6.2c.5 2.3 1.2 4.5 2 6.7.1.2.2.5.2.7 3.6 9.4 9.3 17.5 15.7 21.2.8.5 1.6.8 2.4 1.2.4.2.9.3 1.3.5l1.2.3c1.3.2 2.6.2 3.8 0l.5-.1c.2-.1.5-.1.7-.2l.6-.2.6-.3c.2-.1.4-.2.5-.3.1-.1.2-.1.3-.2 0 0 .1 0 .1-.1 4.6-2.9 7.5-9.8 7.5-19.4 0-2.5-.2-5.1-.6-7.6z"
            />
            <path
              fill="#252B43"
              d="M402.6 285.8c0 3.8-2 5.7-4.5 4.3s-4.5-5.7-4.5-9.5 2-5.7 4.5-4.3c.7.4 1.3 1 1.8 1.7.2 2.5 1.1 4.8 2.6 6.8.1.4.1.7.1 1z"
            />
            <path
              opacity={0.4}
              fill="#FFF"
              d="M415.1 285.8c0 9.9-3.1 16.9-7.8 19.6-1 .5-4.5 2.6-5.9 3.4 4.6-2.9 7.5-9.8 7.5-19.4 0-2.5-.2-5.1-.6-7.6-2.1-14.3-9.8-28.5-19-33.8-4.3-2.5-8.2-2.6-11.4-.9 1.4-.8 4.9-2.8 5.9-3.4 3.3-1.9 7.4-1.8 11.8.7 9.2 5.3 16.9 19.5 19 33.9.3 2.4.5 5 .5 7.5z"
            />
            <path
              fill="#353596"
              d="M408.8 289.4c0 9.6-2.9 16.5-7.5 19.4 1.4-.8 5-2.9 5.9-3.4 4.8-2.8 7.8-9.7 7.8-19.6v-1.1l-6.3 3.6c.1.4.1.8.1 1.1z"
            />
            <path
              fill="#252B43"
              d="M408.8 289.4c0 9.6-2.9 16.5-7.5 19.4 1.4-.8 5-2.9 5.9-3.4 4.8-2.8 7.8-9.7 7.8-19.6v-1.1l-6.3 3.6c.1.4.1.8.1 1.1z"
            />
            <g fill="#252B43">
              <path d="M370.6 263.3v2l-56-32.3 1-.6v-.8l55 31.7z" />
              <path d="M370.6 264.2v1.2l-56-32.3 1-.6 55 31.7z" />
            </g>
            <ellipse
              transform="rotate(-17.074 389.166 278.087)"
              opacity={0.15}
              fill="none"
              stroke="#000"
              strokeMiterlimit={10}
              cx={389.2}
              cy={278.1}
              rx={14.8}
              ry={27.7}
            />
            <path
              opacity={0.4}
              fill="#FFF"
              d="M372.3 253.1c-.9 1.9-1.6 4-2 6.1L314.6 227l6.3-3.6 51.4 29.7z"
            />
          </g>
          <g>
            <path
              fill="#FFCDA7"
              d="M444.8 256.3c2.9-5.5 6.3-18 7.9-24.2 2.4-8.9-1.5-14.5-5.8-14.7-2.7.4-11.6 32.9-11.6 32.9-1 .8-14.6 7.7-18.9 9.4-.8.3-1.6.3-2.4 0-2.1-.8-3.5-.6-5.6-.8-1.6-.2-2.4-.7-2.6-.4-.4.9-.1 1.9.8 2.4s1.8.9 2.8 1.2c-1.8.5-3.6.8-5.4.7-4.2-.1-5.7 1.7-2.5 6 2 2.7 5.3 3.5 12.7 1 2.1-.7 5-2.2 7.7-3.1 5.5-2 7-2.2 11.2-3.7 6.2-2.2 10.4-4.3 11.7-6.7z"
            />
            <path
              fill="#252B43"
              d="M445.3 216.5c2.6.3 5 .9 6.5 3s2.7 5 1.2 13c-1.1 5.6-2.6 11.1-4.5 16.5 0 0-5.9 2.5-12.3-3.9l4.3-16.8c.1-.1.9-11 4.8-11.8z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
